import { Tooltip } from 'react-tooltip';
import React, { useRef } from 'react';
import PropTypes from 'prop-types';

// FontAwesome.
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// DataObjects.
import { ActionDataObject } from '@exonet/jsonapi-data-collections';

// Styled.
import * as S from './styled';

const safeId = (prefix = 'action-status') => `${prefix}-${crypto.randomUUID()}`;

const ActionStatus = ({ action, title }) => {
  const id = useRef(safeId());

  return (
    <S.Status action={action} id={id.current}>
      <FontAwesomeIcon icon={action.getIconType()} size="lg" />
      <span>{(title ?? action.getStatus()).toLowerCase()}</span>
      <Tooltip
        anchorSelect={`#${id.current}`}
        positionStrategy="fixed"
        fallbackPlacements={['top-left']}
        border="1px solid var(--rt-border-color, transparent)"
      >
        {(title ?? action.getStatus()).toLowerCase()}
      </Tooltip>
    </S.Status>
  );
};

ActionStatus.propTypes = {
  action: PropTypes.instanceOf(ActionDataObject).isRequired,
  title: PropTypes.string,
};

export default ActionStatus;
